import { Box, Button, EmptyStateBase } from "@skailer-com/uikit";
import * as Sentry from "@sentry/react";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useRouteError } from "react-router-dom";

export default function RootErrorBoundary() {
  const { t } = useTranslation();
  const error = useRouteError();

  useEffect(() => {
    Sentry.captureException(error, { tags: { module: "root-error-boundary" } });
  }, [error]);

  return (
    <Box className="flex min-h-screen items-center justify-center bg-light">
      <EmptyStateBase
        emoji={":shrug:"}
        title={t("errors:crash_title")}
        description={t("errors:crash_description")}
        primaryButton={
          <Button
            variant={"secondary"}
            onClick={() => {
              window.location.href = "/";
            }}
          >
            {t("common:go_to_home")}
          </Button>
        }
      />
    </Box>
  );
}
